export default __webpack_public_path__ + "static/media/tea_cup_01.f3401701.webp";